import { render } from "./NewOpportunityBtn.vue?vue&type=template&id=83323460"
import script from "./NewOpportunityBtn.vue?vue&type=script&lang=js"
export * from "./NewOpportunityBtn.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__